export default{
    id: 'Id',
    name: 'Name',
    organisation_id: 'Organisations Id',
    creator_user_id: 'Ersteller Id',
    year_id: 'Jahres Id',
    funding_program_id: 'Förderprogramm Id',
    status_id: 'Status Id',

    // Status
    key: 'Schlüssel',

    // Unterschrift
    signatory: 'Unterzeichner/-in',
    form: 'Formular',

    // Maßnahme
    event_id: 'Maßnahmen-ID',
    start_date: 'Startdatum',
    end_date: 'Enddatum',
    duration: 'Dauer',
    street: 'Straße',
    house_number: 'Hausnummer',
    zipcode: 'Postleitzahl',
    city: 'Stadt',
    country: 'Land',

    // Vorgang
    process_id: 'ID',
    serial_number: 'Lfd. Nr.',
    subsidy_max: 'Höchstmögliche Förderung',
    total_cost: 'Gesamtkosten',
    subsidy_rate: 'Zuschuss-Quote',
    subsidy_amount: 'Zuschusshöhe',

    // Formular
    form_process_id: 'Formular Id',
    bank_account_id: 'Bank Account Id',
    formable_id: 'Formable',
    formable_type: 'Formulartyp',
    data: 'Daten',

    // Programmnachweis
    date: 'Datum',
    start: "Start",
    end: "Ende",
    hours: "Stunden",
    description: "Beschreibung",

    // Personen
    event_person_id: 'Person Id',
    function: 'Funktion',
    gender: 'Geschlecht',
    firstname: 'Vorname',
    lastname: 'Nachname',
    birthday: 'Geburtstag',
    participation_begin: 'Beginn der Teilnahme',
    participation_end: 'Ende der Teilnahme',
    participation_duration: 'Dauer der Teilnahme',

    // Dokument
    document_id: 'Dokument Id',
    upload_box_identifier: 'Upload Box',
    visibility_section: 'Sichtbarkeit'
}